import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  const formattedViews = video.views >= 10000
    ? `${(video.views / 10000).toFixed(1)}万`
    : video.views.toString();

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/30 hover:border-primary-500/30 transition-all duration-300"
      data-product-shop
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 91在线视频`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded whitespace-nowrap">
          {video.duration}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded whitespace-nowrap">
          {video.rating}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h4 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {video.title}
        </h4>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formattedViews}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {video.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}